import React from "react";

import { GetActiveRoomsAndDesksResponse } from "../../../../api/grpc/insights/insights";
import {
  ActiveRoomsAndDesksRequest,
  useInsightsRequests,
} from "../../../../api/grpc/insights/useInsightsRequests";
import useGrpcQuery from "../../../../lib/hooks/useGrpcQuery";
import { InsightsLoaderModal } from "../../../shared/InsightsLoaderModal/InsightsLoaderModal";
import { useDelayedLoading } from "../../../../lib/hooks/useDelayedLoading";

interface Props {
  isLoading: boolean;
  insightsType: "rooms" | "desks";
  onCancel: () => void;
  delayMs?: number;
}

export const InsightsLoaderModalController = ({
  isLoading,
  insightsType,
  onCancel,
  delayMs = 10000,
}: Props) => {
  const { getActiveRoomsAndDesks } = useInsightsRequests();
  const shouldShow = useDelayedLoading(isLoading, delayMs);
  const { data } = useGrpcQuery<
    ActiveRoomsAndDesksRequest,
    GetActiveRoomsAndDesksResponse
  >({
    method: getActiveRoomsAndDesks,
    variables: {
      locationID: "",
    },
  });

  return (
    <InsightsLoaderModal
      isOpen={shouldShow}
      insightsType={insightsType}
      roomsCount={data?.activeRoomsCount}
      desksCount={data?.activeDesksCount}
      onCancel={onCancel}
    />
  );
};
